import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';

import { isDevMode } from '../../utils/constants';

import profileImg from '../../assets/images/profile-img.png';

const Login = (props) => {
  return (
    <div className="account-pages d-flex align-items-center justify-content-center" style={{ height: '97vh' }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <div className="bg-soft-primary">
                <Row>
                  <Col className="col-7">
                    <div className="text-primary p-4">
                      <h5 className="text-primary">Admin Panel</h5>
                      <p className="mb-0">Sign in to continue</p>
                    </div>
                  </Col>
                  <Col className="col-5 align-self-end text-end">
                    <img width={isDevMode ? 100 : ''} src={profileImg} className="img-fluid" />
                  </Col>
                </Row>
              </div>
              <CardBody className="">
                <div className="p-0">
                  <div className="text-center">
                    <h5 className="text-primary mb-4">Login to New Admin System</h5>
                    <p className="text-muted mb-4">
                      We have migrated to a new admin system. Please click the button below to login.
                    </p>
                    <a
                      href={`${process.env.REACT_APP_NEW_SMK_STAGING_URL}`}
                      className="btn btn-primary w-100 waves-effect waves-light">
                      Login Using New System
                    </a>
                  </div>
                </div>
              </CardBody>
            </Card>

            <div className="mt-4 text-center">
              <a target="_blank" rel="noreferrer" href={'/branding'} className="text-primary text-center">
                View Branding Page
              </a>
              <p className="mt-2">© {new Date().getFullYear()} ParentsNKids.</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
